import { useStage } from './useStage'

export default () => useStage('totp-authentication')
